"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSchemaService = void 0;
var applicationclosed = __importStar(require("./eventSchemas/platformEvents/applicationclosed.json"));
var applicationready = __importStar(require("./eventSchemas/platformEvents/applicationready.json"));
var applicationprogress = __importStar(require("./eventSchemas/platformEvents/applicationprogress.json"));
var applicationloaded = __importStar(require("./eventSchemas/platformEvents/applicationloaded.json"));
var handleerror = __importStar(require("./eventSchemas/platformEvents/handleerror.json"));
var initcontext = __importStar(require("./eventSchemas/platformEvents/initcontext.json"));
var platformready = __importStar(require("./eventSchemas/platformEvents/platformready.json"));
var sessionupdated = __importStar(require("./eventSchemas/platformEvents/sessionupdated.json"));
var tokenexpired = __importStar(require("./eventSchemas/platformEvents/tokenexpired.json"));
var tokenrefreshed = __importStar(require("./eventSchemas/platformEvents/tokenrefreshed.json"));
var getappsconfig = __importStar(require("./eventSchemas/platformEvents/getappsconfig.json"));
var appsconfigresult = __importStar(require("./eventSchemas/platformEvents/appsconfigresult.json"));
var contextbizctxupdated = __importStar(require("./eventSchemas/platformEvents/contextbizctxupdated.json"));
var contextuiupdated = __importStar(require("./eventSchemas/platformEvents/contextuiupdated.json"));
var openapplication = __importStar(require("./eventSchemas/platformEvents/openapplication.json"));
var initappmetadata = __importStar(require("./eventSchemas/platformEvents/initappmetadata.json"));
var changetitle = __importStar(require("./eventSchemas/applicationEvents/aohs/changetitle.json"));
var cleartitle = __importStar(require("./eventSchemas/applicationEvents/aohs/cleartitle.json"));
var screenshotclicked = __importStar(require("./eventSchemas/applicationEvents/aohs/screenshotclicked.json"));
var screenshotenabled = __importStar(require("./eventSchemas/applicationEvents/aohs/screenshotenabled.json"));
var screenshotresults = __importStar(require("./eventSchemas/applicationEvents/aohs/screenshotresults.json"));
var iosimprogressresults = __importStar(require("./eventSchemas/platformEvents/iosimprogressresults.json"));
var getiosimprogress = __importStar(require("./eventSchemas/platformEvents/getiosimprogress.json"));
var startiosimsimulation = __importStar(require("./eventSchemas/platformEvents/startiosimsimulation.json"));
var pushnavigationstate = __importStar(require("./eventSchemas/applicationEvents/app-shell/pushnavigationstate.json"));
var externalapplicationfailed = __importStar(require("./eventSchemas/applicationEvents/app-shell/externalapplicationfailed.json"));
var backbuttonclicked = __importStar(require("./eventSchemas/platformEvents/backbuttonclicked.json"));
var preparetoclose = __importStar(require("./eventSchemas/applicationEvents/sharedEvents/preparetoclose.json"));
var closeme = __importStar(require("./eventSchemas/applicationEvents/sharedEvents/closeme.json"));
var closingrejected = __importStar(require("./eventSchemas/applicationEvents/sharedEvents/closingrejected.json"));
var applyNavigationState = __importStar(require("./eventSchemas/applicationEvents/app-shell/apply-navigation-state.json"));
var EventSchemaService = /** @class */ (function () {
    function EventSchemaService() {
    }
    EventSchemaService.Schemes = new Map([
        ['platform-ready', platformready],
        ['application-loaded', applicationloaded],
        ['application-closed', applicationclosed],
        ['application-progress', applicationprogress],
        ['application-ready', applicationready],
        ['init-context', initcontext],
        ['token-expired', tokenexpired],
        ['token-refreshed', tokenrefreshed],
        ['session-updated', sessionupdated],
        ['handle-error', handleerror],
        ['get-apps-config', getappsconfig],
        ['apps-config-result', appsconfigresult],
        ['open-application', openapplication],
        ['init-app-metadata', initappmetadata],
        ['context-bizctx-updated', contextbizctxupdated],
        ['context-ui-updated', contextuiupdated],
        ['screenshot-enabled', screenshotenabled],
        ['screenshot-clicked', screenshotclicked],
        ['screenshot-results', screenshotresults],
        ['change-title', changetitle],
        ['clear-title', cleartitle],
        ['get-iosim-progress', getiosimprogress],
        ['iosim-progress-results', iosimprogressresults],
        ['start-iosim-simulation', startiosimsimulation],
        ['push-navigation-state', pushnavigationstate],
        ['external-application-failed', externalapplicationfailed],
        ['back-button-clicked', backbuttonclicked],
        ['prepare-to-close', preparetoclose],
        ['close-me', closeme],
        ['closing-rejected', closingrejected],
        ['apply-navigation-state', applyNavigationState],
    ]);
    return EventSchemaService;
}());
exports.EventSchemaService = EventSchemaService;
